// Standalone entry point — loaded by index.html in dev/preview mode.
// In hosted mode, the host loads ./AppMount directly via Module Federation.
import { prepareRuntime } from "./appMount";

async function boot() {
  await prepareRuntime("boot");
  const { mount } = await import("./bootstrap");
  const devEl = document.getElementById("app");
  if (devEl) {
    await import("./styles/global.css");
    await mount({ $element: devEl, standAlone: true });
  }
}

void boot().catch((error) => console.error("[admin-ui] boot failed", error));
